import React from 'react'
import { Alert, AlertTitle } from '@material-ui/lab'
export const AlertMessage = ({ text }) => {
  return (
    <Alert severity='info'>
      <AlertTitle>Information</AlertTitle>
      {text}
    </Alert>
  )
}
